<template>
  <div class="router-wrapper">
    <div class="element-wrapper">
      <div class="os-tabs-w">
        <div class="os-tabs-controls os-tabs-complex">
          <div class="nav-item">
            <h1>{{ $t("general.test_template") }}</h1>
          </div>
          <div class="nav-item nav-actions d-none d-sm-block">
            <router-link to="templates/create" class="button" size="xlarge" color="primary" icon="left">
              <i class="fas fa-plus"></i>
              <span>{{ $t("templates_index.create_new") }}</span>
            </router-link>
          </div>
        </div>
      </div>
      <div class="content-box">
        <div class="table-responsive">
          <table class="table table-padded">
            <thead>
              <tr>
                <th scope="col">{{ $t("general.name") }}</th>
                <th style="width: 100px">{{ $t("general.actions") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="template in templates">
                <td>{{ template.name }}</td>
                <td>
                  <div class="actions-container">
                    <router-link :to="'/templates/view/' + template.id"
                      ><i class="far fa-eye" style="margin-right: 8px;"></i>
                    </router-link>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="fetching && templates.length < 1" class="element-info-with-icon">
          <div class="element-info-icon">
            <div class="os-icon os-icon-grid-18 element-info-rotate"></div>
          </div>
          <div class="element-info-text">
            <h5 class="element-inner-header">
              {{ $t("templates_index.loading_templates") }}
            </h5>
            <div class="element-inner-desc">
              {{ $t("general.please_wait_data_from_cedoon") }}
            </div>
          </div>
        </div>

        <div v-if="hasError" class="element-info-with-icon">
          <div class="element-info-icon">
            <div class="os-icon os-icon-close"></div>
          </div>
          <div class="element-info-text">
            <h5 class="element-inner-header">{{ $t("general.error.oops") }}</h5>
            <div class="element-inner-desc">
              {{ $t("general.error.communication_error") }}
            </div>
          </div>
        </div>

        <div v-if="!fetching && templates.length < 1" class="element-info-with-icon">
          <div class="element-info-icon">
            <div class="os-icon os-icon-documents-03"></div>
          </div>
          <div class="element-info-text">
            <h5 class="element-inner-header">
              {{ $t("templates_index.no_templates_available") }}
            </h5>
            <div class="element-inner-desc">
              {{ $t("templates_index.start_by_adding_a_new_template") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "TemplatesIndex",
  data() {
    return {};
  },
  computed: {
    ...mapState("templateStore", ["templates", "fetching", "hasError"])
  },
  methods: {
    ...mapActions("templateStore", ["fetch"])
  },
  mounted() {
    this.fetch();
  }
};
</script>

<style scoped>
.actions-container {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
